import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1EarlyBirdModel extends ModelBase<ReservationType1EarlyBirdModel, ReservationType1EarlyBirdDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationTypeId: string = "";

    @observable
    public propertyId: string = "";

    @observable
    public salesAgentIdentityUserId: string = "";

    @observable
    public releaseDateMonth: string = "";

    @observable
    public releaseDateYear: string = "";

    @observable
    public agreedPurchasePrice: string = "";

    @observable
    public anticipatedCompletedDateMonth: string = "";

    @observable
    public anticipatedCompletedDateYear: string = "";

    @observable
    public reservationFeePaid: string = "";

    @observable
    public paymentCash: boolean = false;

    @observable
    public paymentCheque: boolean = false;

    @observable
    public paymentDebit: boolean = false;

    @observable
    public paymentCreditCard: boolean = false;

    @observable
    public paymentBankTransfer: boolean = false;

    @observable
    public pdfUrl: string = "";

    @observable
    public pdfUrlSigned: string = "";

    @observable
    public pdfDocumentId: string = "";

    @observable
    public pdfGenerated: boolean = false;

    @observable
    public pdfGeneratedDate: string = "";

    @observable
    public isComplete: boolean = false;

    @observable
    public completedDate: string = "";

    @observable
    public completedIdentityUserId: string = "";

    @observable
    public reservationDate: string = "";

    @observable
    public drawingNumber1: string = "";

    @observable
    public drawingNumber2: string = "";

    @observable
    public buildStage: string = "";

    @observable
    public notesLegalCopy: string = "";

    @observable
    public isRoofedAndWaterproof?: boolean = undefined;

    @observable
    public releaseFromDate: Date | null = null;

    @observable
    public releaseToDate: Date | null = null;
    //#endregion roperties

    @action
    public fromDto = (reservationDto: ReservationType1EarlyBirdDTO): void => {
        this.id = reservationDto.id;
        this.reservationTypeId = reservationDto.reservationTypeId;
        this.propertyId = reservationDto.propertyId;
        this.salesAgentIdentityUserId = reservationDto.salesAgentIdentityUserId;
        this.releaseDateMonth = reservationDto.releaseDateMonth;
        this.releaseDateYear = reservationDto.releaseDateYear;
        this.agreedPurchasePrice = reservationDto.agreedPurchasePrice;
        this.anticipatedCompletedDateMonth = reservationDto.anticipatedCompletedDateMonth;
        this.anticipatedCompletedDateYear = reservationDto.anticipatedCompletedDateYear;
        this.reservationFeePaid = reservationDto.reservationFeePaid;
        this.paymentCash = reservationDto.paymentCash;
        this.paymentCheque = reservationDto.paymentCheque;
        this.paymentDebit = reservationDto.paymentDebit;
        this.paymentCreditCard = reservationDto.paymentCreditCard;
        this.paymentBankTransfer = reservationDto.paymentBankTransfer;
        this.pdfUrl = reservationDto.pdfUrl;
        this.pdfUrlSigned = reservationDto.pdfUrlSigned;
        this.pdfDocumentId = reservationDto.pdfDocumentId;
        this.pdfGenerated = reservationDto.pdfGenerated;
        this.pdfGeneratedDate = reservationDto.pdfGeneratedDate;
        this.isComplete = reservationDto.isComplete;
        this.completedDate = reservationDto.completedDate;
        this.completedIdentityUserId = reservationDto.completedIdentityUserId;
        this.reservationDate = reservationDto.reservationDate;
        this.drawingNumber1 = reservationDto.drawingNumber1;
        this.drawingNumber2 = reservationDto.drawingNumber2;
        this.buildStage = reservationDto.buildStage;
        this.notesLegalCopy = reservationDto.notesLegalCopy;
        this.isRoofedAndWaterproof = reservationDto.isRoofedAndWaterproof;
        this.releaseFromDate = reservationDto.releaseFromDate;
        this.releaseToDate = reservationDto.releaseToDate;
    };

    public toDto = (): ReservationType1EarlyBirdDTO => {
        return {
            id: this.id,
            reservationTypeId: this.reservationTypeId,
            propertyId: this.propertyId,
            salesAgentIdentityUserId: this.salesAgentIdentityUserId,
            releaseDateMonth: this.releaseDateMonth,
            releaseDateYear: this.releaseDateYear,
            agreedPurchasePrice: this.agreedPurchasePrice,
            anticipatedCompletedDateMonth: this.anticipatedCompletedDateMonth,
            anticipatedCompletedDateYear: this.anticipatedCompletedDateYear,
            reservationFeePaid: this.reservationFeePaid,
            paymentCash: this.paymentCash,
            paymentCheque: this.paymentCheque,
            paymentDebit: this.paymentDebit,
            paymentCreditCard: this.paymentCreditCard,
            paymentBankTransfer: this.paymentBankTransfer,
            pdfUrl: this.pdfUrl,
            pdfUrlSigned: this.pdfUrlSigned,
            pdfDocumentId: this.pdfDocumentId,
            pdfGenerated: this.pdfGenerated,
            pdfGeneratedDate: this.pdfGeneratedDate,
            isComplete: this.isComplete,
            completedDate: this.completedDate,
            completedIdentityUserId: this.completedIdentityUserId,
            reservationDate: this.reservationDate,
            drawingNumber1: this.drawingNumber1,
            drawingNumber2: this.drawingNumber2,
            buildStage: this.buildStage,
            notesLegalCopy: this.notesLegalCopy,
            isRoofedAndWaterproof: this.isRoofedAndWaterproof,
            releaseFromDate: this.releaseFromDate,
            releaseToDate: this.releaseToDate,
        };
    };
}

export interface ReservationType1EarlyBirdDTO {
    id: string | undefined;
    reservationTypeId: string;
    propertyId: string;
    salesAgentIdentityUserId: string;
    releaseDateMonth: string;
    releaseDateYear: string;
    agreedPurchasePrice: string;
    anticipatedCompletedDateMonth: string;
    anticipatedCompletedDateYear: string;
    reservationFeePaid: string;
    paymentCash: boolean;
    paymentCheque: boolean;
    paymentDebit: boolean;
    paymentCreditCard: boolean;
    paymentBankTransfer: boolean;
    pdfUrl: string;
    pdfUrlSigned: string;
    pdfDocumentId: string;
    pdfGenerated: boolean;
    pdfGeneratedDate: string;
    isComplete: boolean;
    completedDate: string;
    completedIdentityUserId: string;
    reservationDate: string;
    drawingNumber1: string;
    drawingNumber2: string;
    buildStage: string;
    notesLegalCopy: string;
    isRoofedAndWaterproof?: boolean;
    releaseFromDate: Date | null;
    releaseToDate: Date | null;
}
